module.exports = __webpack_public_path__ + "8eaf72b2d0317d6d9eb7edeb02bde637.png";